export type StatesAndCities = {
  [key: string]: string[]; // This allows any string as a key
};

export const statesAndCities: StatesAndCities = {
  Aguascalientes: [
    "Aguascalientes",
    "Asientos",
    "Calvillo",
    "Cosío",
    "El Llano",
    "Jesús María",
    "Pabellón de Arteaga",
    "Rincón de Romos",
    "San Francisco de los Romo",
    "San José de Gracia",
    "Tepezalá",
  ],
  "Baja California": [
    "Tijuana",
    "Mexicali",
    "Ensenada",
    "Playas de Rosarito",
    "Tecate",
    "San Quintín",
  ],
  "Baja California Sur": ["La Paz", "Los Cabos", "Loreto", "Comondú", "Mulegé"],
  Campeche: [
    "Campeche",
    "Ciudad del Carmen",
    "Champotón",
    "Escárcega",
    "Calkiní",
    "Hecelchakán",
    "Tenabo",
    "Palizada",
    "Calakmul",
    "Candelaria",
    "Hopelchén",
    "Dzitbalché",
    "Seybaplaya",
  ],

  Chiapas: [
    "Tuxtla Gutiérrez",
    "San Cristóbal de las Casas",
    "Tapachula",
    "Comitán de Domínguez",
    "Pijijiapan",
    "Palenque",
    "Ocosingo",
    "Chiapa de Corzo",
    "Simojovel",
    "Cintalapa",
    "Villaflores",
    "Tonalá",
    "Arriaga",
    "Las Margaritas",
    "Altamirano",
    "Yajalón",
    "Teopisca",
    "Venustiano Carranza",
    "Villa Corzo",
    "Berriozábal",
    "Acala",
    "Chiapilla",
    "Suchiapa",
    "Amatenango del Valle",
    "Tenejapa",
    "Chamula",
    "Zinacantán",
    "Huixtán",
    "Oxchuc",
    "Chanal",
    "Larráinzar",
    "Chenalhó",
    "Pantelhó",
    "Chalchihuitán",
    "Aldama",
    "Santiago el Pinar",
    "Bochil",
    "Jitotol",
    "Pueblo Nuevo Solistahuacán",
    "Rayón",
    "Totolapa",
    "Amatán",
    "Huitiupán",
    "Sabanilla",
    "Tila",
    "Salto de Agua",
    "Tumbalá",
    "Chilón",
    "Sitalá",
    "Reforma",
    "Juárez",
    "Ostuacán",
    "Pichucalco",
    "Sunuapa",
    "Tecpatán",
    "Copainalá",
    "Coapilla",
    "Pantepec",
    "Ixhuatán",
    "Ixtacomitán",
    "Ixtapangajoya",
    "Nicolás Ruíz",
    "El Bosque",
    "Soyaló",
    "Ixtapa",
    "Tapilula",
    "Rayón",
    "Francisca Sarabia",
    "La Concordia",
    "Villa Comaltitlán",
    "Escuintla",
    "Acapetahua",
    "Acacoyagua",
    "Huixtla",
    "Tuzantán",
    "Huehuetán",
    "Mazatán",
    "Metapa",
    "Tuxtla Chico",
    "Frontera Comalapa",
    "La Trinitaria",
    "Independencia",
    "Tzimol",
    "Chicomuselo",
    "Bejucal de Ocampo",
    "Bella Vista",
    "Amatenango de la Frontera",
    "Mazapa de Madero",
    "Motozintla",
    "Porvenir",
    "Siltepec",
    "El Porvenir",
    "Montecristo de Guerrero",
    "La Grandeza",
  ],

  Chihuahua: [
    "Chihuahua",
    "Ciudad Juárez",
    "Delicias",
    "Cuauhtémoc",
    "Nuevo Casas Grandes",
    "Camargo",
    "Hidalgo del Parral",
    "Ojinaga",
    "Ahumada",
    "Guachochi",
    "Madera",
    "Bocoyna",
    "Guerrero",
    "Ascensión",
    "Janos",
    "Casas Grandes",
    "Galeana",
    "Ignacio Zaragoza",
    "Guadalupe y Calvo",
    "Balleza",
    "Rosales",
    "Meoqui",
    "Saucillo",
    "Julimes",
    "López",
    "Aldama",
    "Allende",
    "Valle de Zaragoza",
    "Jiménez",
    "Coronado",
    "Villa López",
    "San Francisco del Oro",
    "Santa Bárbara",
    "Chinipas",
    "Temósachic",
    "Ocampo",
    "Uruachi",
    "Chínipas",
    "Batopilas",
    "Urique",
    "Morelos",
    "Huejotitán",
    "Matamoros",
    "Rosario",
    "Santa Isabel",
    "Namiquipa",
    "Bachíniva",
    "Buenaventura",
    "Gómez Farías",
    "Gran Morelos",
    "Matachí",
    "Nonoava",
    "Riva Palacio",
    "San Francisco de Borja",
    "San Francisco de Conchos",
    "Satevó",
    "Praxedis G. Guerrero",
    "Manuel Benavides",
    "Coyame del Sotol",
    "La Cruz",
    "Moris",
    "El Tule",
    "Maguarichi",
    "Carichí",
    "Belisario Domínguez",
  ],

  Coahuila: [
    "Saltillo",
    "Torreón",
    "Monclova",
    "Piedras Negras",
    "Ciudad Acuña",
    "Frontera",
    "San Pedro de las Colonias",
    "Sabinas",
    "Múzquiz",
    "Matamoros",
    "Parras de la Fuente",
    "General Cepeda",
    "Ramos Arizpe",
    "Arteaga",
    "San Buenaventura",
    "Castaños",
    "Nadadores",
    "Cuatro Ciénegas",
    "Ocampo",
    "Sacramento",
    "Jiménez",
    "Francisco I. Madero",
    "Viesca",
    "Bilbao",
    "Candela",
    "Abasolo",
    "Hidalgo",
    "Morelos",
    "Nava",
    "Villa Unión",
    "Allende",
    "Guerrero",
    "Zaragoza",
    "Juárez",
    "Progreso",
    "Escobedo",
    "Lamadrid",
  ],

  Colima: [
    "Colima",
    "Manzanillo",
    "Tecomán",
    "Villa de Álvarez",
    "Comala",
    "Coquimatlán",
    "Armería",
    "Cuauhtémoc",
    "Ixtlahuacán",
    "Minatitlán",
  ],

  Durango: [
    "Durango",
    "Gómez Palacio",
    "Lerdo",
    "Pueblo Nuevo",
    "Santiago Papasquiaro",
    "Canatlán",
    "El Oro",
    "Mapimí",
    "Cuencamé",
    "Guadalupe Victoria",
    "Nombre de Dios",
    "Mezquital",
    "San Dimas",
    "Tamazula",
    "Topia",
    "Tepehuanes",
    "Guanaceví",
    "Hidalgo",
    "Indé",
    "Nazas",
    "Rodeo",
    "San Bernardo",
    "San Juan del Río",
    "San Juan de Guadalupe",
    "San Luis del Cordero",
    "Santa Clara",
    "Súchil",
    "Tlahualilo",
    "Vicente Guerrero",
    "Nuevo Ideal",
    "Coneto de Comonfort",
    "Pánuco de Coronado",
    "Peñón Blanco",
    "Poanas",
    "General Simón Bolívar",
    "Ocampo",
    "San Pedro del Gallo",
    "Santa María del Oro",
    "Otáez",
  ],

  Guanajuato: [
    "Guanajuato",
    "León",
    "Irapuato",
    "Celaya",
    "Salamanca",
    "San Miguel de Allende",
    "Pénjamo",
    "Dolores Hidalgo",
    "Silao",
    "Acámbaro",
    "Moroleón",
    "Uriangato",
    "Yuriria",
    "Valle de Santiago",
    "Salvatierra",
    "Cortazar",
    "Villagrán",
    "Apaseo el Grande",
    "Apaseo el Alto",
    "Comonfort",
    "San Francisco del Rincón",
    "Purísima del Rincón",
    "Manuel Doblado",
    "Cuerámaro",
    "Romita",
    "San Felipe",
    "San Diego de la Unión",
    "San Luis de la Paz",
    "Doctor Mora",
    "Tierra Blanca",
    "Victoria",
    "Xichú",
    "Santa Catarina",
    "Atarjea",
    "Ocampo",
    "Coroneo",
    "Jerécuaro",
    "Tarandacuao",
    "Tarimoro",
    "Huanímaro",
    "Abasolo",
    "Pueblo Nuevo",
    "Santa Cruz de Juventino Rosas",
    "Santiago Maravatío",
    "Jaral del Progreso",
    "San José Iturbide",
  ],

  Guerrero: [
    "Chilpancingo de los Bravo",
    "Acapulco de Juárez",
    "Iguala de la Independencia",
    "Taxco de Alarcón",
    "Zihuatanejo de Azueta",
    "Coyuca de Benítez",
    "Tlapa de Comonfort",
    "Chilapa de Álvarez",
    "Ometepec",
    "Petatlán",
    "Técpan de Galeana",
    "Ayutla de los Libres",
    "Tixtla de Guerrero",
    "Pungarabato",
    "Arcelia",
    "Tlapehuala",
    "Coyuca de Catalán",
    "Cutzamala de Pinzón",
    "San Marcos",
    "Florencio Villarreal",
    "Cruz Grande",
    "Copala",
    "Marquelia",
    "Azoyú",
    "Juchitán",
    "Cuajinicuilapa",
    "Xochistlahuaca",
    "Tlacoachistlahuaca",
    "Igualapa",
    "Cuautepec",
    "Olinalá",
    "Cualac",
    "Huamuxtitlán",
    "Xalpatláhuac",
    "Zapotitlán Tablas",
    "Alpoyeca",
    "Ahuacuotzingo",
    "Tlalixtaquilla de Maldonado",
    "Atlixtac",
    "Alcozauca de Guerrero",
    "Copanatoyac",
    "Malinaltepec",
    "Metlatónoc",
    "Cochoapa el Grande",
    "Iliatenco",
    "Tlacoapa",
    "Acatepec",
    "José Joaquín de Herrera",
    "General Heliodoro Castillo",
    "Leonardo Bravo",
    "Eduardo Neri",
    "Quechultenango",
    "Mártir de Cuilapan",
    "Zitlala",
    "Apaxtla",
    "Copalillo",
    "Mochitlán",
    "Juan R. Escudero",
    "Acapulco de Juárez",
    "Coyuca de Benítez",
    "Benito Juárez",
    "La Unión de Isidoro Montes de Oca",
    "Zihuatanejo de Azueta",
    "Petatlán",
    "Técpan de Galeana",
    "Atoyac de Álvarez",
    "Benito Juárez",
    "Coyuca de Catalán",
    "Cutzamala de Pinzón",
    "Tlapehuala",
    "Arcelia",
    "Ajuchitlán del Progreso",
    "San Miguel Totolapan",
    "Tlalchapa",
    "Pilcaya",
    "Tetipac",
    "Buenavista de Cuéllar",
    "Ixcateopan de Cuauhtémoc",
    "Taxco de Alarcón",
    "Tepecoacuilco de Trujano",
    "Huitzuco de los Figueroa",
    "Iguala de la Independencia",
    "Buenavista de Cuéllar",
    "Cocula",
    "Cuetzala del Progreso",
  ],

  Hidalgo: [
    "Pachuca de Soto",
    "Tulancingo de Bravo",
    "Tizayuca",
    "Mineral de la Reforma",
    "Tula de Allende",
    "Actopan",
    "Ixmiquilpan",
    "Mixquiahuala de Juárez",
    "Tepeji del Río de Ocampo",
    "Huejutla de Reyes",
    "Zempoala",
    "Apan",
    "Tepeapulco",
    "Almoloya",
    "Progreso de Obregón",
    "Villa de Tezontepec",
    "Tlahuelilpan",
    "Tlaxcoapan",
    "Atitalaquia",
    "Atotonilco de Tula",
    "Chapantongo",
    "Nopala de Villagrán",
    "Jasso",
    "Francisco I. Madero",
    "San Agustín Tlaxiaca",
    "Ajacuba",
    "Chilcuautla",
    "Tasquillo",
    "Zimapán",
    "Jacala de Ledezma",
    "Nicolás Flores",
    "Pacula",
    "La Misión",
    "Cardonal",
    "Santiago de Anaya",
    "El Arenal",
    "Metztitlán",
    "San Agustín Metzquititlán",
    "Huasca de Ocampo",
    "Atotonilco el Grande",
    "Metepec",
    "Acaxochitlán",
    "Agua Blanca de Iturbide",
    "Cuautepec de Hinojosa",
    "Huehuetla",
    "San Bartolo Tutotepec",
    "Tenango de Doria",
    "Tlanchinol",
    "Yahualica",
    "Molango de Escamilla",
    "Lolotla",
    "Xochicoatlán",
    "Juárez Hidalgo",
    "Calnali",
    "Zacualtipán de Ángeles",
    "Tianguistengo",
    "Pisaflores",
    "Chapulhuacán",
    "Jacala de Ledezma",
    "Eloxochitlán",
    "Omitlán de Juárez",
    "Singuilucan",
    "Villa de Tezontepec",
    "Zapotlán de Juárez",
    "San Salvador",
    "Epazoyucan",
    "San Agustín Tlaxiaca",
    "Mineral del Chico",
    "Mineral del Monte",
    "Acatlán",
    "Alfajayucan",
    "Tlahuiltepa",
    "Cardonal",
  ],

  Jalisco: [
    "Acatic",
    "Acatlán de Juárez",
    "Ahualulco de Mercado",
    "Amacueca",
    "Amatitán",
    "Ameca",
    "Antonio Escobedo",
    "Arandas",
    "El Arenal",
    "Atemajac de Brizuela",
    "Atengo",
    "Atenguillo",
    "Atotonilco el Alto",
    "Atoyac",
    "Autlán de Navarro",
    "Ayotlán",
    "Ayutla",
    "La Barca",
    "Bolaños",
    "Cabo Corrientes",
    "Casimiro Castillo",
    "Cañadas de Obregón",
    "Cihuatlán",
    "Zapotlán el Grande",
    "Cocula",
    "Colotlán",
    "Concepción de Buenos Aires",
    "Cuautitlán de García Barragán",
    "Cuautla",
    "Cuquío",
    "Chapala",
    "Chimaltitán",
    "Chiquilistlán",
    "Degollado",
    "Ejutla",
    "Encarnación de Díaz",
    "Etzatlán",
    "El Grullo",
    "Gómez Farías",
    "Guachinango",
    "Guadalajara",
    "Hostotipaquillo",
    "Huejúcar",
    "Huejuquilla el Alto",
    "La Huerta",
    "Ixtlahuacán del Río",
    "Ixtlahuacán de los Membrillos",
    "Jalostotitlán",
    "Jamay",
    "Jesús María",
    "Jilotlán de los Dolores",
    "Jocotepec",
    "Juanacatlán",
    "Juchitlán",
    "Lagos de Moreno",
    "El Limón",
    "Magdalena",
    "Santa María de los Ángeles",
    "La Manzanilla de la Paz",
    "Mascota",
    "Mazamitla",
    "Mexticacán",
    "Mezquitic",
    "Mixtlán",
    "Ocotlán",
    "Ojuelos de Jalisco",
    "Pihuamo",
    "Poncitlán",
    "Puerto Vallarta",
    "Villa Purificación",
    "Quitupan",
    "El Salto",
    "San Cristóbal de la Barranca",
    "San Diego de Alejandría",
    "San Juan de los Lagos",
    "San Julián",
    "San Marcos",
    "San Martín de Bolaños",
    "San Martín de Hidalgo",
    "San Miguel el Alto",
    "Gómez Farías",
    "San Sebastián del Oeste",
    "Santa María del Oro",
    "Sayula",
    "Tala",
    "Talpa de Allende",
    "Tamazula de Gordiano",
    "Tapalpa",
    "Tecalitlán",
    "Tecolotlán",
    "Techaluta de Montenegro",
    "Tenamaxtlán",
    "Teocaltiche",
    "Teocuitatlán de Corona",
    "Tepatitlán de Morelos",
    "Tequila",
    "Teuchitlán",
    "Tizapán el Alto",
    "Tlajomulco de Zúñiga",
    "San Pedro Tlaquepaque",
    "Tolimán",
    "Tomatlán",
    "Tonalá",
    "Tonaya",
    "Tonila",
    "Totatiche",
    "Tototlán",
    "Tuxcacuesco",
    "Tuxcueca",
    "Tuxpan",
    "Unión de San Antonio",
    "Unión de Tula",
    "Valle de Guadalupe",
    "Valle de Juárez",
    "San Gabriel",
    "Villa Corona",
    "Villa Guerrero",
    "Villa Hidalgo",
    "Yahualica de González Gallo",
    "Zacoalco de Torres",
    "Zapopan",
    "Zapotiltic",
    "Zapotitlán de Vadillo",
    "Zapotlán del Rey",
    "Zapotlanejo",
    "San Ignacio Cerro Gordo",
  ],

  "Estado de México": [
    "Toluca",
    "Ecatepec de Morelos",
    "Naucalpan de Juárez",
    "Tlalnepantla de Baz",
    "Cuautitlán Izcalli",
    "Chimalhuacán",
    "Ixtapaluca",
    "Zinacantepec",
    "Nezahualcóyotl",
    "Atizapán de Zaragoza",
    "Cuautitlán",
    "Tultitlán",
    "Coacalco de Berriozábal",
    "Chalco",
    "La Paz",
    "Texcoco",
    "Huixquilucan",
    "Valle de Chalco Solidaridad",
    "Nicolás Romero",
    "Tecámac",
    "Metepec",
    "Lerma",
    "Chicoloapan",
    "Tultepec",
    "Tepotzotlán",
    "Zumpango",
    "Huehuetoca",
    "Chiautla",
    "Melchor Ocampo",
    "Nextlalpan",
    "Teoloyucan",
    "Isidro Fabela",
    "Jilotzingo",
    "Jaltenco",
    "Tequixquiac",
    "Villa del Carbón",
    "Apaxco",
    "Hueypoxtla",
    "Otumba",
    "Axapusco",
    "Nopaltepec",
    "San Martín de las Pirámides",
    "Temascalapa",
    "Acolman",
    "Tepetlaoxtoc",
    "Papalotla",
    "Chiconcuac",
    "Atenco",
    "Chiautla",
    "Tezoyuca",
    "Tepetlixpa",
    "Cocotitlán",
    "Tlalmanalco",
    "Amecameca",
    "Ayapango",
    "Atlautla",
    "Ozumba",
    "Juchitepec",
    "Tenango del Aire",
    "Chalco de Díaz Covarrubias",
    "Ixtapaluca",
    "Valle de Chalco Solidaridad",
    "Almoloya de Juárez",
    "Villa de Allende",
    "Ixtlahuaca",
    "Jocotitlán",
    "Atlacomulco",
    "El Oro",
    "San Felipe del Progreso",
    "San José del Rincón",
    "Temascalcingo",
    "Acambay de Ruíz Castañeda",
    "Chapa de Mota",
    "Aculco",
    "Polotitlán",
    "Soyaniquilpan de Juárez",
    "Jilotepec",
    "Arroyo Zarco",
    "Xonacatlán",
    "Otzolotepec",
    "Xalatlaco",
    "Tianguistenco",
    "Capulhuac",
    "Santiago Tianguistenco",
    "Almoloya del Río",
    "Texcalyacac",
    "Rayón",
    "Tonatico",
    "Villa Guerrero",
    "Coatepec Harinas",
    "Almoloya de Alquisiras",
    "Sultepec",
    "Texcaltitlán",
    "Temascaltepec",
    "San Simón de Guerrero",
    "Tejupilco",
    "Luvianos",
    "Amatepec",
    "Tlatlaya",
    "Otzoloapan",
    "Zacazonapan",
    "Valle de Bravo",
    "Amanalco",
    "Villa de Allende",
    "Donato Guerra",
    "Ixtapan del Oro",
    "Santo Tomás",
    "Otzoloapan",
    "Zacualpan",
    "Ixtapan de la Sal",
    "Tonatico",
    "Malinalco",
    "Ocuilan",
    "Tenancingo",
    "Zumpahuacán",
    "Villa Guerrero",
    "Coatepec Harinas",
    "Almoloya de Alquisiras",
    "Sultepec",
    "San Antonio la Isla",
    "Chapultepec",
    "Mexicaltzingo",
    "Calimaya",
    "Santa Cruz Atizapán",
    "Almoloya de Juárez",
    "Zinacantepec",
    "Toluca",
    "Metepec",
    "San Mateo Atenco",
    "Ocoyoacac",
    "Huixquilucan",
    "Lerma",
    "Xonacatlán",
    "Otzolotepec",
  ],

  Michoacán: [
    "Acuitzio",
    "Aguililla",
    "Álvaro Obregón",
    "Angamacutiro",
    "Angangueo",
    "Apatzingán",
    "Aporo",
    "Aquila",
    "Ario",
    "Arteaga",
    "Briseñas",
    "Buenavista",
    "Carácuaro",
    "Coahuayana",
    "Coalcomán de Vázquez Pallares",
    "Coeneo",
    "Contepec",
    "Copándaro",
    "Cotija",
    "Cuitzeo",
    "Charapan",
    "Charo",
    "Chavinda",
    "Cherán",
    "Chilchota",
    "Chinicuila",
    "Chucándiro",
    "Churintzio",
    "Churumuco",
    "Ecuandureo",
    "Epitacio Huerta",
    "Erongarícuaro",
    "Gabriel Zamora",
    "Hidalgo",
    "La Huacana",
    "Huandacareo",
    "Huaniqueo",
    "Huetamo",
    "Huiramba",
    "Indaparapeo",
    "Irimbo",
    "Ixtlán",
    "Jacona",
    "Jiménez",
    "Jiquilpan",
    "Juárez",
    "Jungapeo",
    "Lagunillas",
    "Madero",
    "Maravatío",
    "Marcos Castellanos",
    "Lázaro Cárdenas",
    "Michoacán de Ocampo",
    "Morelia",
    "Morelos",
    "Múgica",
    "Nahuatzen",
    "Nocupétaro",
    "Nuevo Parangaricutiro",
    "Nuevo Urecho",
    "Numarán",
    "Ocampo",
    "Pajacuarán",
    "Panindícuaro",
    "Parácuaro",
    "Paracho",
    "Pátzcuaro",
    "Penjamillo",
    "Peribán",
    "La Piedad",
    "Purándiro",
    "Puruándiro",
    "Queréndaro",
    "Quiroga",
    "Cojumatlán de Régules",
    "Los Reyes",
    "Sahuayo",
    "San Lucas",
    "Santa Ana Maya",
    "Salvador Escalante",
    "Senguio",
    "Susupuato",
    "Tacámbaro",
    "Tancítaro",
    "Tangamandapio",
    "Tangancícuaro",
    "Tanhuato",
    "Taretan",
    "Tarímbaro",
    "Tepalcatepec",
    "Tingambato",
    "Tingüindín",
    "Tiquicheo de Nicolás Romero",
    "Tlalpujahua",
    "Tlazazalca",
    "Tocumbo",
    "Tumbiscatío",
    "Turicato",
    "Tuxpan",
    "Tuzantla",
    "Tzintzuntzan",
    "Tzitzio",
    "Uruapan",
    "Venustiano Carranza",
    "Villamar",
    "Vista Hermosa",
    "Yurécuaro",
    "Zacapu",
    "Zamora",
    "Zináparo",
    "Zinapécuaro",
    "Ziracuaretiro",
    "Zitácuaro",
    "José Sixto Verduzco",
    "Régules",
    "Churintzio",
    "Chinicuila",
    "Churumuco",
    "Epitacio Huerta",
    "Marcos Castellanos",
    "Susupuato de Guerrero",
    "Tiquicheo de Nicolás Romero",
    "José Sixto Verduzco",
  ],

  Morelos: [
    "Amacuzac",
    "Atlatlahucan",
    "Axochiapan",
    "Ayala",
    "Coatlán del Río",
    "Cuautla",
    "Cuernavaca",
    "Emiliano Zapata",
    "Huitzilac",
    "Jantetelco",
    "Jiutepec",
    "Jojutla",
    "Jonacatepec de Leandro Valle",
    "Mazatepec",
    "Miacatlán",
    "Ocuituco",
    "Puente de Ixtla",
    "Temixco",
    "Temoac",
    "Tepalcingo",
    "Tepoztlán",
    "Tetecala",
    "Tetela del Volcán",
    "Tlalnepantla",
    "Tlaltizapán de Zapata",
    "Tlaquiltenango",
    "Tlayacapan",
    "Totolapan",
    "Xochitepec",
    "Yautepec",
    "Yecapixtla",
    "Zacatepec",
    "Zacualpan de Amilpas",
    "Temoac",
  ],

  Nayarit: [
    "Acaponeta",
    "Ahuacatlán",
    "Amatlán de Cañas",
    "Compostela",
    "Huajicori",
    "Ixtlán del Río",
    "Jala",
    "Xalisco",
    "Del Nayar",
    "Rosamorada",
    "Ruíz",
    "San Blas",
    "San Pedro Lagunillas",
    "Santa María del Oro",
    "Santiago Ixcuintla",
    "Tecuala",
    "Tepic",
    "Tuxpan",
    "La Yesca",
    "Bahía de Banderas",
  ],

  "Nuevo León": [
    "Abasolo",
    "Agualeguas",
    "Los Aldamas",
    "Allende",
    "Anáhuac",
    "Apodaca",
    "Aramberri",
    "Bustamante",
    "Cadereyta Jiménez",
    "Carmen",
    "Cerralvo",
    "Ciénega de Flores",
    "China",
    "Doctor Arroyo",
    "Doctor Coss",
    "Doctor González",
    "Galeana",
    "García",
    "San Pedro Garza García",
    "General Bravo",
    "General Escobedo",
    "General Terán",
    "General Treviño",
    "General Zaragoza",
    "General Zuazua",
    "Guadalupe",
    "Los Herreras",
    "Higueras",
    "Hualahuises",
    "Iturbide",
    "Juárez",
    "Lampazos de Naranjo",
    "Linares",
    "Marín",
    "Melchor Ocampo",
    "Mier y Noriega",
    "Mina",
    "Montemorelos",
    "Monterrey",
    "Parás",
    "Pesquería",
    "Los Ramones",
    "Rayones",
    "Sabinas Hidalgo",
    "Salinas Victoria",
    "San Nicolás de los Garza",
    "Hidalgo",
    "Santa Catarina",
    "Santiago",
    "Vallecillo",
    "Villaldama",
  ],
  Oaxaca: [
    "Abejones",
    "Acatlán de Pérez Figueroa",
    "Asunción Cacalotepec",
    "Asunción Cuyotepeji",
    "Asunción Ixtaltepec",
    "Asunción Nochixtlán",
    "Asunción Ocotlán",
    "Asunción Tlacolulita",
    "Ayotzintepec",
    "El Barrio de la Soledad",
    "Calihualá",
    "Candelaria Loxicha",
    "Ciénega de Zimatlán",
    "Ciudad Ixtepec",
    "Coatecas Altas",
    "Coixtlahuaca",
    "Concepción Buenavista",
    "Concepción Pápalo",
    "Constancia del Rosario",
    "Cosolapa",
    "Cosoltepec",
    "Cuilápam de Guerrero",
    "Cuyamecalco Villa de Zaragoza",
    "Chahuites",
    "Chalcatongo de Hidalgo",
    "Chiquihuitlán de Benito Juárez",
    "Heroica Ciudad de Ejutla de Crespo",
    "Eloxochitlán de Flores Magón",
    "El Espinal",
    "Tamazulápam del Espíritu Santo",
    "Fresnillo de Trujano",
    "Guadalupe Etla",
    "Guadalupe de Ramírez",
    "Guelatao de Juárez",
    "Guevea de Humboldt",
    "Mesones Hidalgo",
    "Villa Hidalgo",
    "Heroica Ciudad de Huajuapan de León",
    "Huautepec",
    "Huautla de Jiménez",
    "Ixtlán de Juárez",
    "Heroica Ciudad de Juchitán de Zaragoza",
    "Loma Bonita",
    "Magdalena Apasco",
    "Magdalena Jaltepec",
    "Santa Magdalena Jicotlán",
    "Magdalena Mixtepec",
    "Magdalena Ocotlán",
    "Magdalena Peñasco",
    "Magdalena Teitipac",
    "Magdalena Tequisistlán",
    "Magdalena Tlacotepec",
    "Magdalena Zahuatlán",
    "Mariscala de Juárez",
    "Mártires de Tacubaya",
    "Matías Romero Avendaño",
    "Mazatlán Villa de Flores",
    "Miahuatlán de Porfirio Díaz",
    "Mixistlán de la Reforma",
    "Monjas",
    "Natividad",
    "Nazareno Etla",
    "Nejapa de Madero",
    "Ixpantepec Nieves",
    "Santiago Niltepec",
    "Oaxaca de Juárez",
    "Ocotlán de Morelos",
    "La Pe",
    "Pinotepa de Don Luis",
    "Pluma Hidalgo",
    "San José del Progreso",
    "Putla Villa de Guerrero",
    "Santa Catarina Quioquitani",
    "Reforma de Pineda",
    "La Reforma",
    "Reyes Etla",
    "Rojas de Cuauhtémoc",
    "Salina Cruz",
    "San Agustín Amatengo",
    "San Agustín Atenango",
    "San Agustín Chayuco",
    "San Agustín de las Juntas",
    "San Agustín Etla",
    "San Agustín Loxicha",
    "San Agustín Tlacotepec",
    "San Agustín Yatareni",
    "San Andrés Cabecera Nueva",
    "San Andrés Dinicuiti",
    "San Andrés Huaxpaltepec",
    "San Andrés Huayápam",
    "San Andrés Ixtlahuaca",
    "San Andrés Lagunas",
    "San Andrés Nuxiño",
    "San Andrés Paxtlán",
    "San Andrés Sinaxtla",
    "San Andrés Solaga",
    "San Andrés Teotilálpam",
    "San Andrés Tepetlapa",
    "San Andrés Yaá",
    "San Andrés Zabache",
    "San Andrés Zautla",
    "San Antonino Castillo Velasco",
    "San Antonino el Alto",
    "San Antonino Monte Verde",
    "San Antonio Acutla",
    "San Antonio de la Cal",
    "San Antonio Huitepec",
    "San Antonio Nanahuatípam",
    "San Antonio Sinicahua",
    "San Antonio Tepetlapa",
    "San Baltazar Chichicápam",
    "San Baltazar Loxicha",
    "San Baltazar Yatzachi el Bajo",
    "San Bartolo Coyotepec",
    "San Bartolomé Ayautla",
    "San Bartolomé Loxicha",
    "San Bartolomé Quialana",
    "San Bartolomé Yucuañe",
    "San Bartolomé Zoogocho",
    "San Bernardo Mixtepec",
    "San Blas Atempa",
    "San Carlos Yautepec",
    "San Cristóbal Amatlán",
    "San Cristóbal Amoltepec",
    "San Cristóbal Lachirioag",
    "San Cristóbal Suchixtlahuaca",
    "San Diego de la Mesa Tochimiltzingo",
    "San Dionisio del Mar",
    "San Dionisio Ocotepec",
    "San Dionisio Ocotlán",
    "San Esteban Atatlahuca",
    "San Felipe Jalapa de Díaz",
    "San Felipe Tejalápam",
    "San Felipe Usila",
    "San Francisco Cahuacuá",
    "San Francisco Cajonos",
    "San Francisco Chapulapa",
    "San Francisco Chindúa",
    "San Francisco del Mar",
    "San Francisco Huehuetlán",
    "San Francisco Ixhuatán",
    "San Francisco Jaltepetongo",
    "San Francisco Lachigoló",
    "San Francisco Logueche",
    "San Francisco Nuxaño",
    "San Francisco Ozolotepec",
    "San Francisco Sola",
    "San Francisco Telixtlahuaca",
    "San Francisco Teopan",
    "San Francisco Tlapancingo",
    "San Gabriel Mixtepec",
    "San Ildefonso Amatlán",
    "San Ildefonso Sola",
    "San Ildefonso Villa Alta",
    "San Jacinto Amilpas",
    "San Jacinto Tlacotepec",
    "San Jerónimo Coatlán",
    "San Jerónimo Silacayoapilla",
    "San Jerónimo Sosola",
    "San Jerónimo Taviche",
    "San Jerónimo Tecóatl",
    "San Jorge Nuchita",
    "San José Ayuquila",
    "San José Chiltepec",
    "San José del Peñasco",
    "San José Estancia Grande",
    "San José Independencia",
    "San José Lachiguiri",
    "San José Tenango",
    "San Juan Achiutla",
    "San Juan Atepec",
    "San Juan Bautista Atatlahuca",
    "San Juan Bautista Coixtlahuaca",
    "San Juan Bautista Cuicatlán",
    "San Juan Bautista Guelache",
    "San Juan Bautista Jayacatlán",
    "San Juan Bautista Lo de Soto",
    "San Juan Bautista Suchitepec",
    "San Juan Bautista Tlacoatzintepec",
    "San Juan Bautista Tlachichilco",
    "San Juan Bautista Tuxtepec",
    "San Juan Cacahuatepec",
    "San Juan Chicomezúchil",
    "San Juan Chilateca",
    "San Juan Cieneguilla",
    "San Juan Coatzóspam",
    "San Juan Colorado",
    "San Juan Comaltepec",
    "San Juan Cotzocón",
    "San Juan Diuxi",
    "San Juan Evangelista Analco",
    "San Juan Guelavía",
    "San Juan Guichicovi",
    "San Juan Ihualtepec",
    "San Juan Juquila Vijanos",
    "San Juan Lachao",
    "San Juan Lachigalla",
    "San Juan Lajarcia",
    "San Juan Lalana",
    "San Juan de los Cués",
    "San Juan Mazatlán",
    "San Juan Mixtepec",
    "San Juan Ñumí",
    "San Juan Ozolotepec",
    "San Juan Petlapa",
    "San Juan Quiahije",
    "San Juan Quiotepec",
    "San Juan Sayultepec",
    "San Juan Tabaá",
    "San Juan Tamazola",
    "San Juan Teita",
    "San Juan Teitipac",
    "San Juan Tepeuxila",
    "San Juan Teposcolula",
    "San Juan Yaeé",
    "San Juan Yatzona",
    "San Juan Yucuita",
    "San Lorenzo",
    "San Lorenzo Albarradas",
    "San Lorenzo Cacaotepec",
    "San Lorenzo Cuaunecuiltitla",
    "San Lorenzo Texmelúcan",
    "San Lorenzo Victoria",
    "San Lucas Camotlán",
    "San Lucas Ojitlán",
    "San Lucas Quiaviní",
    "San Lucas Zoquiápam",
    "San Luis Amatlán",
    "San Marcial Ozolotepec",
    "San Marcos Arteaga",
    "San Martín de los Cansecos",
    "San Martín Huamelúlpam",
    "San Martín Itunyoso",
    "San Martín Lachilá",
    "San Martín Peras",
    "San Martín Tilcajete",
    "San Martín Toxpalan",
    "San Martín Zacatepec",
    "San Mateo Cajonos",
    "San Mateo del Mar",
    "San Mateo Etlatongo",
    "San Mateo Nejápam",
    "San Mateo Peñasco",
    "San Mateo Piñas",
    "San Mateo Río Hondo",
    "San Mateo Sindihui",
    "San Mateo Tlapiltepec",
    "San Mateo Yoloxochitlán",
    "San Mateo Yucutindoo",
    "San Melchor Betaza",
    "San Miguel Achiutla",
    "San Miguel Ahuehuetitlán",
    "San Miguel Aloápam",
    "San Miguel Amatitlán",
    "San Miguel Amatlán",
    "San Miguel Coatlán",
    "San Miguel Chicahua",
    "San Miguel Chimalapa",
    "San Miguel del Puerto",
    "San Miguel del Río",
    "San Miguel Ejutla",
    "San Miguel el Grande",
    "San Miguel Huautla",
    "San Miguel Mixtepec",
    "San Miguel Panixtlahuaca",
    "San Miguel Peras",
    "San Miguel Piedras",
    "San Miguel Quetzaltepec",
    "San Miguel Santa Flor",
    "San Miguel Soyaltepec",
    "San Miguel Suchixtepec",
    "San Miguel Tecomatepec",
    "San Miguel Tenango",
    "San Miguel Tequixtepec",
    "San Miguel Tilquiápam",
    "San Miguel Tlacamama",
    "San Miguel Tlacotepec",
    "San Miguel Tulancingo",
    "San Miguel Yotao",
    "San Nicolás",
    "San Nicolás Hidalgo",
    "San Pablo Coatlán",
    "San Pablo Cuatro Venados",
    "San Pablo Etla",
    "San Pablo Huitzo",
    "San Pablo Huixtepec",
    "San Pablo Macuiltianguis",
    "San Pablo Tijaltepec",
    "San Pablo Villa de Mitla",
    "San Pablo Yaganiza",
    "San Pedro Amuzgos",
    "San Pedro Apóstol",
    "San Pedro Atoyac",
    "San Pedro Cajonos",
    "San Pedro Coxcaltepec Cántaros",
    "San Pedro Comitancillo",
    "San Pedro el Alto",
    "San Pedro Huamelula",
    "San Pedro Huilotepec",
    "San Pedro Ixcatlán",
    "San Pedro Ixtlahuaca",
    "San Pedro Jaltepetongo",
    "San Pedro Jicayán",
    "San Pedro Jocotipac",
    "San Pedro Juchatengo",
    "San Pedro Mártir",
    "San Pedro Mártir Quiechapa",
    "San Pedro Mártir Yucuxaco",
    "San Pedro Mixtepec",
    "San Pedro Molinos",
    "San Pedro Nopala",
    "San Pedro Ocopetatillo",
    "San Pedro Pochutla",
    "San Pedro Quiatoni",
    "San Pedro Sochiápam",
    "San Pedro Tapanatepec",
    "San Pedro Taviche",
    "San Pedro Teozacoalco",
    "San Pedro Teutila",
    "San Pedro Tidaá",
    "San Pedro Topiltepec",
    "San Pedro Totolápam",
    "San Pedro Totolapan",
    "San Pedro Yaneri",
    "San Pedro Yólox",
    "San Pedro Yucunama",
    "San Pedro y San Pablo Ayutla",
    "San Pedro y San Pablo Teposcolula",
    "San Pedro y San Pablo Tequixtepec",
    "San Raymundo Jalpan",
    "San Sebastián Abasolo",
    "San Sebastián Coatlán",
    "San Sebastián Ixcapa",
    "San Sebastián Nicananduta",
    "San Sebastián Río Hondo",
    "San Sebastián Tecomaxtlahuaca",
    "San Sebastián Teitipac",
    "San Sebastián Tutla",
    "San Simón Almolongas",
    "San Simón Zahuatlán",
    "Santa Ana",
    "Santa Ana Ateixtlahuaca",
    "Santa Ana Cuauhtémoc",
    "Santa Ana del Valle",
    "Santa Ana Tavela",
    "Santa Ana Tlapacoyan",
    "Santa Ana Yareni",
    "Santa Ana Zegache",
    "Santa Catalina Quierí",
    "Santa Catarina Cuixtla",
    "Santa Catarina Ixtepeji",
    "Santa Catarina Juquila",
    "Santa Catarina Lachatao",
    "Santa Catarina Loxicha",
    "Santa Catarina Mechoacán",
    "Santa Catarina Minas",
    "Santa Catarina Quiané",
    "Santa Catarina Tayata",
    "Santa Catarina Ticuá",
    "Santa Catarina Yosonotú",
    "Santa Catarina Zapoquila",
    "Santa Cruz Acatepec",
    "Santa Cruz Amilpas",
    "Santa Cruz de Bravo",
    "Santa Cruz Itundujia",
    "Santa Cruz Mixtepec",
    "Santa Cruz Nundaco",
    "Santa Cruz Papalutla",
    "Santa Cruz Tacache de Mina",
    "Santa Cruz Tacahua",
    "Santa Cruz Tayata",
    "Santa Cruz Xitla",
    "Santa Cruz Xoxocotlán",
    "Santa Cruz Zenzontepec",
    "Santa Gertrudis",
    "Santa Inés del Monte",
    "Santa Inés de Zaragoza",
    "Santa Inés Yatzeche",
    "Santa Lucía del Camino",
    "Santa Lucía Miahuatlán",
    "Santa Lucía Monteverde",
    "Santa Lucía Ocotlán",
    "Santa María Alotepec",
    "Santa María Apazco",
    "Santa María la Asunción",
    "Santa María Atzompa",
    "Santa María Camotlán",
    "Santa María Colotepec",
    "Santa María Cortijo",
    "Santa María Coyotepec",
    "Santa María Chachoápam",
    "Santa María Chilchotla",
    "Santa María Chimalapa",
    "Santa María del Rosario",
    "Santa María del Tule",
    "Santa María Ecatepec",
    "Santa María Guelacé",
    "Santa María Guienagati",
    "Santa María Huatulco",
    "Santa María Huazolotitlán",
    "Santa María Ipalapa",
    "Santa María Ixcatlán",
    "Santa María Jacatepec",
    "Santa María Jalapa del Marqués",
    "Santa María Jaltianguis",
    "Santa María Lachixío",
    "Santa María Mixistepec",
    "Santa María Nativitas",
    "Santa María Nduayaco",
    "Santa María Ozolotepec",
    "Santa María Pápalo",
    "Santa María Peñoles",
    "Santa María Petapa",
    "Santa María Quiegolani",
    "Santa María Sola",
    "Santa María Tataltepec",
    "Santa María Tecomavaca",
    "Santa María Temaxcalapa",
    "Santa María Temaxcaltepec",
    "Santa María Teopoxco",
    "Santa María Tepantlali",
    "Santa María Texcatitlán",
    "Santa María Tlahuitoltepec",
    "Santa María Tlalixtac",
    "Santa María Tonameca",
    "Santa María Totolapilla",
    "Santa María Xadani",
    "Santa María Yalina",
    "Santa María Yavesía",
    "Santa María Yolotepec",
    "Santa María Yosoyúa",
    "Santa María Yucuhiti",
    "Santa María Zacatepec",
    "Santa María Zaniza",
    "Santa María Zoquitlán",
    "Santiago Amoltepec",
    "Santiago Apoala",
    "Santiago Apóstol",
    "Santiago Astata",
    "Santiago Atitlán",
    "Santiago Ayuquililla",
    "Santiago Cacaloxtepec",
    "Santiago Camotlán",
    "Santiago Comaltepec",
    "Santiago Chazumba",
    "Santiago Choápam",
    "Santiago del Río",
    "Santiago Huajolotitlán",
    "Santiago Huauclilla",
    "Santiago Ihuitlán Plumas",
    "Santiago Ixcuintepec",
    "Santiago Ixtayutla",
    "Santiago Jamiltepec",
    "Santiago Jocotepec",
    "Santiago Juxtlahuaca",
    "Santiago Lachiguiri",
    "Santiago Lalopa",
    "Santiago Laollaga",
    "Santiago Laxopa",
    "Santiago Llano Grande",
    "Santiago Matatlán",
    "Santiago Miltepec",
    "Santiago Minas",
    "Santiago Nacaltepec",
    "Santiago Nejapilla",
    "Santiago Nundiche",
    "Santiago Nuyoó",
    "Santiago Pinotepa Nacional",
    "Santiago Suchilquitongo",
    "Santiago Tamazola",
    "Santiago Tapextla",
    "Santiago Tenango",
    "Santiago Tepetlapa",
    "Santiago Tetepec",
    "Santiago Texcalcingo",
    "Santiago Textitlán",
    "Santiago Tilantongo",
    "Santiago Tillo",
    "Santiago Tlazoyaltepec",
    "Santiago Xanica",
    "Santiago Xiacuí",
    "Santiago Yaitepec",
    "Santiago Yaveo",
    "Santiago Yolomécatl",
    "Santiago Yosondúa",
    "Santiago Yucuyachi",
    "Santiago Zacatepec",
    "Santiago Zoochila",
    "Silacayoápam",
    "Sitio de Xitlapehua",
    "Soledad Etla",
    "Villa de Tamazulápam del Progreso",
    "Tanetze de Zaragoza",
    "Taniche",
    "Tataltepec de Valdés",
    "Teococuilco de Marcos Pérez",
    "Teotitlán de Flores Magón",
    "Teotitlán del Valle",
    "Teotongo",
    "Tepelmeme Villa de Morelos",
    "Heroica Villa Tezoatlán de Segura y Luna",
    "Tiahuixtla",
    "Tilapa",
    "Tlacochauaya",
    "Tlacotepec Plumas",
    "Tlalixtac de Cabrera",
    "Totontepec Villa de Morelos",
    "Trinidad Zaachila",
    "La Trinidad Vista Hermosa",
    "Unión Hidalgo",
    "Valerio Trujano",
    "San Juan Bautista Valle Nacional",
    "Villa Díaz Ordaz",
    "Yaxe",
    "Yogana",
    "Yutanduchi de Guerrero",
    "Villa de Zaachila",
    "San Mateo Yucutindoo",
    "Zapotitlán del Río",
    "Zapotitlán Lagunas",
    "Zapotitlán Palmas",
    "Santa Inés Yatzeche",
  ],

  Puebla: [
    "Acajete",
    "Acateno",
    "Acatlán",
    "Acatzingo",
    "Acteopan",
    "Ahuacatlán",
    "Ahuatlán",
    "Ahuazotepec",
    "Ahuehuetitla",
    "Ajalpan",
    "Albino Zertuche",
    "Aljojuca",
    "Altepexi",
    "Amixtlán",
    "Amozoc",
    "Aquixtla",
    "Atempan",
    "Atexcal",
    "Atlixco",
    "Atoyatempan",
    "Atzala",
    "Atzitzihuacán",
    "Atzitzintla",
    "Axutla",
    "Ayotoxco de Guerrero",
    "Calpan",
    "Caltepec",
    "Camocuautla",
    "Cañada Morelos",
    "Capulhuac",
    "Coatepec",
    "Coatzingo",
    "Cohetzala",
    "Cohuecan",
    "Coronango",
    "Cohuecán",
    "Cuapiaxtla de Madero",
    "Cuautempan",
    "Cuautinchán",
    "Cuautlancingo",
    "Cuayuca de Andrade",
    "Cuetzalan del Progreso",
    "Cuyoaco",
    "Chalchicomula de Sesma",
    "Chapulco",
    "Chiautla",
    "Chiautzingo",
    "Chiconcuautla",
    "Chichiquila",
    "Chietla",
    "Chigmecatitlán",
    "Chignahuapan",
    "Chignautla",
    "Chila",
    "Chila de la Sal",
    "Honey",
    "Chilchotla",
    "Chinantla",
    "Domingo Arenas",
    "Eloxochitlán",
    "Epatlán",
    "Esperanza",
    "Francisco Z. Mena",
    "General Felipe Ángeles",
    "Guadalupe",
    "Guadalupe Victoria",
    "Hermenegildo Galeana",
    "Huaquechula",
    "Huatlatlauca",
    "Huauchinango",
    "Huehuetla",
    "Huehuetlán el Chico",
    "Huejotzingo",
    "Hueyapan",
    "Hueytamalco",
    "Hueytlalpan",
    "Huitzilan de Serdán",
    "Huitziltepec",
    "Atlequizayan",
    "Ixcamilpa de Guerrero",
    "Ixcaquixtla",
    "Ixtacamaxtitlán",
    "Ixtepec",
    "Izúcar de Matamoros",
    "Jalpan",
    "Jolalpan",
    "Jonotla",
    "Jopala",
    "Juan C. Bonilla",
    "Juan Galindo",
    "Juan N. Méndez",
    "Lafragua",
    "Libres",
    "La Magdalena Tlatlauquitepec",
    "Mazapiltepec de Juárez",
    "Mixtla",
    "Molcaxac",
    "Cañada Morelos",
    "Naupan",
    "Nauzontla",
    "Nealtican",
    "Nicolás Bravo",
    "Nopalucan",
    "Ocotepec",
    "Ocoyucan",
    "Olintla",
    "Oriental",
    "Pahuatlán",
    "Palmar de Bravo",
    "Pantepec",
    "Petlalcingo",
    "Piaxtla",
    "Puebla",
    "Quecholac",
    "Quimixtlán",
    "Rafael Lara Grajales",
    "Los Reyes de Juárez",
    "San Andrés Cholula",
    "San Antonio Cañada",
    "San Diego la Mesa Tochimiltzingo",
    "San Felipe Teotlalcingo",
    "San Felipe Tepatlán",
    "San Gabriel Chilac",
    "San Gregorio Atzompa",
    "San Jerónimo Tecuanipan",
    "San Jerónimo Xayacatlán",
    "San José Chiapa",
    "San José Miahuatlán",
    "San Juan Atenco",
    "San Juan Atzompa",
    "San Lorenzo",
    "San Lucas El Grande",
    "San Lucas Teteletlán",
    "San Martín Texmelucan",
    "San Martín Totoltepec",
    "San Matías Tlalancaleca",
    "San Miguel Ixitlán",
    "San Miguel Xoxtla",
    "San Nicolás Buenos Aires",
    "San Nicolás de los Ranchos",
    "San Pablo Anicano",
    "San Pedro Cholula",
    "San Pedro Yeloixtlahuaca",
    "San Salvador el Seco",
    "San Salvador el Verde",
    "San Salvador Huixcolotla",
    "San Sebastián Tlacotepec",
    "Santa Catarina Tlaltempan",
    "Santa Inés Ahuatempan",
    "Santa Isabel Cholula",
    "Santiago Miahuatlán",
    "Huehuetlán el Grande",
    "Santo Tomás Hueyotlipan",
    "Soltepec",
    "Tecali de Herrera",
    "Tecamachalco",
    "Tecomatlán",
    "Tehuacán",
    "Tehuitzingo",
    "Tenampulco",
    "Teopantlán",
    "Teotlalco",
    "Tepanco de López",
    "Tepango de Rodríguez",
    "Tepatlaxco de Hidalgo",
    "Tepeaca",
    "Tepemaxalco",
    "Tepeojuma",
    "Tepetzintla",
    "Tepexco",
    "Tepexi de Rodríguez",
    "Tepeyahualco",
    "Tepeyahualco de Cuauhtémoc",
    "Tetela de Ocampo",
    "Teteles de Avila Castillo",
    "Teziutlán",
    "Tianguismanalco",
    "Tilapa",
    "Tlacotepec de Benito Juárez",
    "Tlacuilotepec",
    "Tlachichuca",
    "Tlahuapan",
    "Tlaltenango",
    "Tlanepantla",
    "Tlaola",
    "Tlapacoya",
    "Tlapanalá",
    "Tlatlauquitepec",
    "Tlaxco",
    "Tochimilco",
    "Tochtepec",
    "Totoltepec de Guerrero",
    "Tulcingo",
    "Tuzamapan de Galeana",
    "Tzicatlacoyan",
    "Venustiano Carranza",
    "Vicente Guerrero",
    "Xayacatlán de Bravo",
    "Xicotepec",
    "Xicotlán",
    "Xiutetelco",
    "Xochiapulco",
    "Xochiltepec",
    "Xochitlán de Vicente Suárez",
    "Xochitlán Todos Santos",
    "Yaonáhuac",
    "Yehualtepec",
    "Zacapala",
    "Zacapoaxtla",
    "Zacatlán",
    "Zapotitlán",
    "Zapotitlán de Méndez",
    "Zaragoza",
    "Zautla",
    "Zihuateutla",
    "Zinacatepec",
    "Zongozotla",
    "Zoquiapan",
    "Zoquitlán",
  ],

  Querétaro: [
    "Amealco de Bonfil",
    "Arroyo Seco",
    "Cadereyta de Montes",
    "Colón",
    "Corregidora",
    "El Marqués",
    "Ezequiel Montes",
    "Huimilpan",
    "Jalpan de Serra",
    "Landa de Matamoros",
    "Pedro Escobedo",
    "Peñamiller",
    "Pinal de Amoles",
    "Querétaro",
    "San Joaquín",
    "San Juan del Río",
    "Tequisquiapan",
    "Tolimán",
  ],

  "Quintana Roo": [
    "Bacalar",
    "Benito Juárez",
    "Cozumel",
    "Felipe Carrillo Puerto",
    "Isla Mujeres",
    "José María Morelos",
    "Lázaro Cárdenas",
    "Othón P. Blanco",
    "Puerto Morelos",
    "Solidaridad",
    "Tulum",
  ],

  "San Luis Potosí": [
    "Ahualulco",
    "Alaquines",
    "Aquismón",
    "Armadillo de los Infante",
    "Cárdenas",
    "Catorce",
    "Cedral",
    "Cerritos",
    "Cerro de San Pedro",
    "Ciudad del Maíz",
    "Ciudad Fernández",
    "Ciudad Valles",
    "Coxcatlán",
    "Charcas",
    "Ebano",
    "Guadalcázar",
    "Hoctún",
    "Lagunillas",
    "Matehuala",
    "Mexquitic de Carmona",
    "Moctezuma",
    "Rayón",
    "Rioverde",
    "Salinas",
    "San Antonio",
    "San Ciro de Acosta",
    "San Luis Potosí",
    "San Martín Chalchicuautla",
    "San Nicolás Tolentino",
    "Santa Catarina",
    "Santa María del Río",
    "Santo Domingo",
    "Soledad de Graciano Sánchez",
    "Tamasopo",
    "Tamazunchale",
    "Tampacán",
    "Tampamolón Corona",
    "Tamuín",
    "Tanlajás",
    "Tanquian de Escobedo",
    "Tierra Nueva",
    "Vanegas",
    "Venado",
    "Villa de Arriaga",
    "Villa de Guadalupe",
    "Villa de la Paz",
    "Villa de Ramos",
    "Villa de Reyes",
    "Villa Hidalgo",
    "Villa Juárez",
    "Xilitla",
    "Zaragoza",
  ],

  Sinaloa: [
    "Ahome",
    "Angostura",
    "Badiraguato",
    "Concordia",
    "Cosalá",
    "Culiacán",
    "Choix",
    "Elota",
    "Escuinapa",
    "El Fuerte",
    "Guasave",
    "Mazatlán",
    "Mocorito",
    "Rosario",
    "Salvador Alvarado",
    "San Ignacio",
    "Sinaloa",
    "Navolato",
  ],
  Sonora: [
    "Aconchi",
    "Agua Prieta",
    "Alamos",
    "Altar",
    "Arivechi",
    "Arizpe",
    "Atil",
    "Bacadéhuachi",
    "Bacanora",
    "Bacerac",
    "Bacoachi",
    "Bácum",
    "Banámichi",
    "Baviácora",
    "Bavispe",
    "Benito Juárez",
    "Benjamín Hill",
    "Caborca",
    "Cajeme",
    "Cananea",
    "Carbó",
    "La Colorada",
    "Cucurpe",
    "Cumpas",
    "Divisaderos",
    "Empalme",
    "Etchojoa",
    "Fronteras",
    "Granados",
    "Guaymas",
    "Hermosillo",
    "Huachinera",
    "Huásabas",
    "Huatabampo",
    "Huépac",
    "Imuris",
    "Magdalena",
    "Mazatán",
    "Moctezuma",
    "Naco",
    "Nácori Chico",
    "Nacozari de García",
    "Navojoa",
    "Nogales",
    "Onavas",
    "Opodepe",
    "Oquitoa",
    "Pitiquito",
    "Puerto Peñasco",
    "Quiriego",
    "Rayón",
    "Rosario",
    "Sahuaripa",
    "San Felipe de Jesús",
    "San Javier",
    "San Luis Río Colorado",
    "San Miguel de Horcasitas",
    "San Pedro de la Cueva",
    "Santa Ana",
    "Santa Cruz",
    "Sáric",
    "Soyopa",
    "Suaqui Grande",
    "Tepache",
    "Trincheras",
    "Tubutama",
    "Ures",
    "Villa Hidalgo",
    "Villa Pesqueira",
    "Yécora",
    "General Plutarco Elías Calles",
    "Benito Juárez",
    "San Ignacio Río Muerto",
  ],

  Tabasco: [
    "Balancán",
    "Cárdenas",
    "Centla",
    "Centro",
    "Comalcalco",
    "Cunduacán",
    "Emiliano Zapata",
    "Huimanguillo",
    "Jalapa",
    "Jalpa de Méndez",
    "Jonuta",
    "Macuspana",
    "Nacajuca",
    "Paraíso",
    "Tacotalpa",
    "Teapa",
    "Tenosique",
  ],
  Tamaulipas: [
    "Abasolo",
    "Aldama",
    "Altamira",
    "Antiguo Morelos",
    "Burgos",
    "Bustamante",
    "Camargo",
    "Casas",
    "Ciudad Madero",
    "Cruillas",
    "Gómez Farías",
    "González",
    "Güémez",
    "Guerrero",
    "Gustavo Díaz Ordaz",
    "Hidalgo",
    "Jaumave",
    "Jiménez",
    "Llera",
    "Mainero",
    "El Mante",
    "Matamoros",
    "Méndez",
    "Mier",
    "Miguel Alemán",
    "Miquihuana",
    "Nuevo Laredo",
    "Nuevo Morelos",
    "Ocampo",
    "Padilla",
    "Palmillas",
    "Reynosa",
    "Río Bravo",
    "San Carlos",
    "San Fernando",
    "San Nicolás",
    "Soto la Marina",
    "Tampico",
    "Tula",
    "Valle Hermoso",
    "Victoria",
    "Villagrán",
    "Xicoténcatl",
  ],

  Tlaxcala: [
    "Acuamanala de Miguel Hidalgo",
    "Amaxac de Guerrero",
    "Apetatitlán de Antonio Carvajal",
    "Apizaco",
    "Atlangatepec",
    "Atltzayanca",
    "Benito Juárez",
    "Calpulalpan",
    "El Carmen Tequexquitla",
    "Carranza",
    "Caxhuacan",
    "Chiautempan",
    "Coaxomulco",
    "Contla de Juan Cuamatzi",
    "Cuapiaxtla",
    "Cuaxomulco",
    "Emiliano Zapata",
    "Españita",
    "Huamantla",
    "Hueyotlipan",
    "Ixtacuixtla de Mariano Matamoros",
    "Ixtenco",
    "Mazatecochco de José María Morelos",
    "Muñoz de Domingo Arenas",
    "Nanacamilpa de Mariano Arista",
    "Natívitas",
    "Panotla",
    "San Damián Texóloc",
    "San Francisco Tetlanohcan",
    "San Jerónimo Zacualpan",
    "San José Teacalco",
    "San Juan Huactzinco",
    "San Lorenzo Axocomanitla",
    "San Lucas Tecopilco",
    "Santa Ana Nopalucan",
    "Santa Apolonia Teacalco",
    "Santa Catarina Ayometla",
    "Santa Cruz Quilehtla",
    "Santa Cruz Tlaxcala",
    "Santa Isabel Xiloxoxtla",
    "Sanctórum de Lázaro Cárdenas",
    "Tepeyanco",
    "Tepintzintla",
    "Terrenate",
    "Tetla de la Solidaridad",
    "Tetlatlahuca",
    "Tlaxcala",
    "Tlaxco",
    "Tocatlán",
    "Totolac",
    "Trinidad Sánchez Santos",
    "Tzompantepec",
    "Xaloztoc",
    "Xaltocan",
    "Yauhquemehcan",
    "Zacatelco",
    "Ziltlaltépec de Trinidad Sánchez Santos",
  ],

  Veracruz: [
    "Acajete",
    "Acatlán",
    "Acayucan",
    "Actopan",
    "Acula",
    "Acultzingo",
    "Camarón de Tejeda",
    "Alpatláhuac",
    "Alto Lucero de Gutiérrez Barrios",
    "Altotonga",
    "Alvarado",
    "Amatitlán",
    "Naranjos Amatlán",
    "Amatlán de los Reyes",
    "Angel R. Cabada",
    "La Antigua",
    "Apazapan",
    "Aquila",
    "Astacinga",
    "Atlahuilco",
    "Atoyac",
    "Atzacan",
    "Atzalan",
    "Tlaltetela",
    "Ayahualulco",
    "Banderilla",
    "Benito Juárez",
    "Boca del Río",
    "Calcahualco",
    "Camerino Z. Mendoza",
    "Carrillo Puerto",
    "Catemaco",
    "Cazones de Herrera",
    "Cerro Azul",
    "Citlaltépetl",
    "Coacoatzintla",
    "Coahuitlán",
    "Coatepec",
    "Coatzacoalcos",
    "Coatzintla",
    "Coetzala",
    "Colipa",
    "Comapa",
    "Córdoba",
    "Cosamaloapan de Carpio",
    "Cosautlán de Carvajal",
    "Coscomatepec",
    "Cosoleacaque",
    "Cotaxtla",
    "Coxquihui",
    "Coyutla",
    "Cuichapa",
    "Cuitláhuac",
    "Chacaltianguis",
    "Chalma",
    "Chiconamel",
    "Chiconquiaco",
    "Chicontepec",
    "Chinameca",
    "Chinampa de Gorostiza",
    "Las Choapas",
    "Chocamán",
    "Chontla",
    "Chumatián",
    "Emiliano Zapata",
    "Espinal",
    "Filomeno Mata",
    "Fortín",
    "Gutiérrez Zamora",
    "Hidalgotitlán",
    "Huatusco",
    "Huayacocotla",
    "Hueyapan de Ocampo",
    "Huiloapan de Cuauhtémoc",
    "Ignacio de la Llave",
    "Ilamatlán",
    "Isla",
    "Ixcatepec",
    "Ixhuacán de los Reyes",
    "Ixhuatlán del Café",
    "Ixhuatlancillo",
    "Ixmatlahuacan",
    "Ixtaczoquitlán",
    "Jalacingo",
    "Xalapa",
    "Jalcomulco",
    "Jáltipan",
    "Jamapa",
    "Jesús Carranza",
    "Xico",
    "Jilotepec",
    "Juan Rodríguez Clara",
    "Juchique de Ferrer",
    "Landero y Coss",
    "Lerdo de Tejada",
    "Lima",
    "Magdalena",
    "Maltrata",
    "Manlio Fabio Altamirano",
    "Mariano Escobedo",
    "Martínez de la Torre",
    "Mecatlán",
    "Mecayapan",
    "Medellín de Bravo",
    "Miahuatlán",
    "Las Minas",
    "Minatitlán",
    "Misantla",
    "Mixtla de Altamirano",
    "Moloacán",
    "Nanchital de Lázaro Cárdenas del Río",
    "Naolinco",
    "Naranjal",
    "Nautla",
    "Nogales",
    "Oluta",
    "Omealca",
    "Orizaba",
    "Otatitlán",
    "Oteapan",
    "Ozuluama de Mascareñas",
    "Pajapan",
    "Pánuco",
    "Papantla",
    "Paso del Macho",
    "Paso de Ovejas",
    "La Perla",
    "Perote",
    "Platón Sánchez",
    "Playa Vicente",
    "Poza Rica de Hidalgo",
    "Las Vigas de Ramírez",
    "Pueblo Viejo",
    "Puente Nacional",
    "Rafael Delgado",
    "Rafael Lucio",
    "Los Reyes",
    "Río Blanco",
    "Saltabarranca",
    "San Andrés Tenejapan",
    "San Andrés Tuxtla",
    "San Juan Evangelista",
    "Santiago Tuxtla",
    "Sayula de Alemán",
    "Soconusco",
    "Sochiapa",
    "Soledad Atzompa",
    "Soledad de Doblado",
    "Soteapan",
    "Tamalín",
    "Tamiahua",
    "Tampico Alto",
    "Tancoco",
    "Tantima",
    "Tantoyuca",
    "Tatatila",
    "Castillo de Teayo",
    "Tecolutla",
    "Tehuipango",
    "Álamo Temapache",
    "Tempoal",
    "Tenampa",
    "Tenochtitlán",
    "Teocelo",
    "Tepatlaxco",
    "Tepetlán",
    "Tepetzintla",
    "Tequila",
    "José Azueta",
    "Texcatepec",
    "Texhuacán",
    "Texistepec",
    "Tezonapa",
    "Tierra Blanca",
    "Tihuatlán",
    "Tlacojalpan",
    "Tlacolulan",
    "Tlacotalpan",
    "Tlacotepec de Mejía",
    "Tlachichilco",
    "Tlahuatlán",
    "Tlalixcoyan",
    "Tlalnelhuayocan",
    "Tlapacoyan",
    "Tlaquilpa",
    "Tlilapan",
    "Tomatlán",
    "Tonayán",
    "Totutla",
    "Tuxpan",
    "Tuxtilla",
    "Ursulo Galván",
    "Vega de Alatorre",
    "Veracruz",
    "Villa Aldama",
    "Xoxocotla",
    "Yanga",
    "Yecuatla",
    "Zacualpan",
    "Zaragoza",
    "Zentla",
    "Zongolica",
    "Zontecomatlán de López y Fuentes",
    "Zozocolco de Hidalgo",
  ],
  Yucatán: [
    "Abalá",
    "Acanceh",
    "Akil",
    "Baca",
    "Bokobá",
    "Buctzotz",
    "Cacalchén",
    "Calotmul",
    "Cansahcab",
    "Cantamayec",
    "Celestún",
    "Cenotillo",
    "Conkal",
    "Cuncunul",
    "Cuzamá",
    "Chacsinkín",
    "Chankom",
    "Chapab",
    "Chemax",
    "Chicxulub Pueblo",
    "Chichimilá",
    "Chikindzonot",
    "Chocholá",
    "Chumayel",
    "Dzán",
    "Dzemul",
    "Dzidzantún",
    "Dzilam de Bravo",
    "Dzilam González",
    "Dzitás",
    "Dzoncauich",
    "Espita",
    "Halachó",
    "Hocabá",
    "Hoctún",
    "Homún",
    "Huhí",
    "Hunucmá",
    "Ixil",
    "Izamal",
    "Kanasín",
    "Kantunil",
    "Kaua",
    "Kinchil",
    "Kopomá",
    "Mama",
    "Maní",
    "Maxcanú",
    "Mayapán",
    "Mérida",
    "Mocochá",
    "Motul",
    "Muna",
    "Muxupip",
    "Opichén",
    "Oxkutzcab",
    "Panabá",
    "Peto",
    "Progreso",
    "Quintana Roo",
    "Río Lagartos",
    "Sacalum",
    "Samahil",
    "San Felipe",
    "Sanahcat",
    "Santa Elena",
    "Seyé",
    "Sinanché",
    "Sotuta",
    "Sucilá",
    "Sudzal",
    "Suma",
    "Tahdziú",
    "Tahmek",
    "Teabo",
    "Tecoh",
    "Tekal de Venegas",
    "Tekantó",
    "Tekax",
    "Tekit",
    "Tekom",
    "Telchac Pueblo",
    "Telchac Puerto",
    "Temax",
    "Temozón",
    "Tepakán",
    "Tetiz",
    "Teya",
    "Ticul",
    "Timucuy",
    "Tinum",
    "Tixcacalcupul",
    "Tixkokob",
    "Tixmehuac",
    "Tixpéhual",
    "Tizimín",
    "Tunkas",
    "Tzucacab",
    "Uayma",
    "Ucú",
    "Umán",
    "Valladolid",
    "Xocchel",
    "Yaxcabá",
    "Yaxkukul",
    "Yobaín",
  ],

  Zacatecas: [
    "Apozol",
    "Apulco",
    "Atolinga",
    "Benito Juárez",
    "Calera",
    "Cañitas de Felipe Pescador",
    "Concepción del Oro",
    "Cuauhtémoc",
    "Chalchihuites",
    "Fresnillo",
    "Trinidad García de la Cadena",
    "Genaro Codina",
    "General Enrique Estrada",
    "General Francisco R. Murguía",
    "El Plateado de Joaquín Amaro",
    "General Pánfilo Natera",
    "Guadalupe",
    "Huanusco",
    "Jalpa",
    "Jerez",
    "Jiménez del Teul",
    "Juan Aldama",
    "Juchipila",
    "Loreto",
    "Luis Moya",
    "Mazapil",
    "Melchor Ocampo",
    "Mezquital del Oro",
    "Miguel Auza",
    "Momax",
    "Monte Escobedo",
    "Morelos",
    "Moyahua de Estrada",
    "Nochistlán de Mejía",
    "Noria de Ángeles",
    "Ojocaliente",
    "Pánuco",
    "Pinos",
    "Río Grande",
    "Sain Alto",
    "El Salvador",
    "Sombrerete",
    "Susticacán",
    "Tabasco",
    "Tepechitlán",
    "Tepetongo",
    "Teúl de González Ortega",
    "Tlaltenango de Sánchez Román",
    "Valparaíso",
    "Vetagrande",
    "Villa de Cos",
    "Villa García",
    "Villa González Ortega",
    "Villa Hidalgo",
    "Villanueva",
    "Zacatecas",
    "Trancoso",
    "Santa María de la Paz",
  ],
};
